<div [formGroup]="formGroup">
    <div [formGroupName]="controlName">
        <input
            pInputText
            [formControlName]="'value'"
            class="w-full"
            placeholder="{{ 'default-cm-enterText' | translate: 'Enter Text' }}"
            [trim]="'blur'"
        />
    </div>
</div>
